module.exports = __webpack_public_path__ + "static/media/feature-more4.86b2caba.png";